export const getApiBaseUrl = () => {
    // If no API host is specified, use relative URLs (for proxy setup)
    if (!process.env.REACT_APP_API_HOST) {
        // In production, use relative URLs to avoid mixed content issues
        // The nginx proxy will handle routing to the backend
        return '';
    }
    
    const apiHost = process.env.REACT_APP_API_HOST;
    
    // Always use HTTPS for API calls when the app is served over HTTPS
    if (window.location.protocol === 'https:') {
        return `https://${apiHost}`;
    }
    
    return `${window.location.protocol}//${apiHost}`;
};

export const API_ENDPOINTS = {
  login: '/ordertracker/userLogin',
  quotes: '/ordertracker/QuotesByCustNo',
  openOrders: '/ordertracker/OpenOrders',
  users: '/ordertracker/Users',
  password: '/ordertracker/GetPW',
  userInfo: '/ordertracker/UserInfo',
  updateLogin: '/ordertracker/UpdateLogin'
};